<template>
  <div class="relative mr-12" v-on-click-away="hidePopup"
       v-show="!user_info.dirty"
       @click="showPopup = !showPopup">
    <div class="flex pr-6 text-white items-center group
                border border-icon-active rounded
                hover:border-border-hover
                transition duration-200 min-w-188px cursor-pointer">
      <div class="border-r border-icon-active group-hover:border-border-hover
                  p-3-5 mr-6
                  transition duration-200">
        <IconWallet/>
      </div>
      <div class="text-md font-medium mr-8">{{ current_portfolio.data.name }}</div>
      <IconBars class="text-icon-active group-hover:text-white ml-auto -mt-0-5 transition duration-200"/>
    </div>
    <HeaderPortfoliosNavigationPopup v-show="showPopup"/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {directive as onClickAway} from "vue-clickaway";
import IconBars from "@/components/icons/IconBars";
import IconWallet from "@/components/icons/IconWallet";
import HeaderPortfoliosNavigationPopup
  from "@/components/common/Header/HeaderPortfolioNavigation/HeaderPortfoliosNavigationPopup";

export default {
  name: "HeaderPortfoliosNavigation",
  components: {HeaderPortfoliosNavigationPopup, IconWallet, IconBars},
  directives: {
    onClickAway: onClickAway
  },
  data() {
    return {
      showPopup: false
    }
  },
  computed: {
    ...mapState('cabinet/user', ['user_info']),
    ...mapState('investments/portfolios', ['current_portfolio']),
  },
  methods: {
    hidePopup() {
      this.showPopup = false;
    }
  }
}
</script>